<ot-form-container [formGroup]="group" *ngIf="duplicateDealId">
  <div class="warning">
    ⚠️ Duplicate Deal Detected! A deal for this address already exists.
    <a [attr.href]="dealUrl" target="_blank"> View existing deal.</a>
    You can proceed with creating a new deal if necessary.
  </div>
</ot-form-container>
